@if (!exportMode) {
<div class="certificate__edit-button-div">
  @if (editMode) {
    <button
      mat-raised-button
      class="certificate__edit-btn certificate__edit-btn--text"
      (click)="onCancelEdit()"
      [disabled]='isCancelDisabled'
    >
      {{ 'general.cancel' | translate }}
    </button>

    <button
      mat-icon-button
      class="certificate__edit-btn certificate__edit-btn--icon"
      (click)="onCancelEdit()"
      [attr.aria-label]="'general.cancel' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
  <button
    mat-flat-button
    class="certificate__edit-btn certificate__edit-btn--text"
    [disabled]="editMode && (!hasChanges() || !isValid() || isSaving)"
    (click)="onToggleEdit()"
  >
    {{ editMode ? ('general.save' | translate) : ('general.edit' | translate) }}
  </button>

  <button
    mat-icon-button
    class="certificate__edit-btn certificate__edit-btn--icon"
    [disabled]="editMode && (!hasChanges() || !isValid() || isSaving)"
    (click)="onToggleEdit()"
    [attr.aria-label]="(editMode ? ('general.save' | translate) : ('general.edit' | translate))"
  >
    <mat-icon>{{ editMode ? 'save' : 'edit' }}</mat-icon>
  </button>
</div>
}

<form [formGroup]="form">
  @if (certificatesFormArray.length > 0) {
    <div formArrayName="zertifikate" class="certificate__wrapper">
      @for (group of certificatesFormArray.controls;
        track group;
        let idx = $index) {
        <mat-card [class.certificate__card--export]="exportMode">
          @if (exportMode) {
            <mat-checkbox
              [checked]="selectedExportIds.includes(group.value.uuid || idx.toString())"
              [disabled]="!canSelectCertificate(group.value.uuid || idx.toString())"
              (change)="toggleExportSelection(group.value.uuid || idx.toString(), $event.checked)"
            ></mat-checkbox>
          }
          <div [formGroupName]="idx" class="certificate__content">
            <div class="certificate__field" [ngClass]="{ 'certificate__field--no-padding': !editMode }">
              @if (!editMode) {
                <mat-label class="certificate__question">{{ 'certificates.period' | translate }}</mat-label>
                <p>{{ group.value.beginn | date: "MM/yyyy" }}</p>
              } @else {
                <mat-form-field>
                  <mat-label class="certificate__question">{{ 'certificates.period' | translate }}</mat-label>
                  <input required matInput [matDatepicker]="datepicker" formControlName="beginn"/>
                  <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
                  <mat-datepicker #datepicker>
                    <mat-datepicker-actions>
                      <button mat-button matDatepickerCancel>{{ 'general.cancel' | translate }}</button>
                      <button mat-flat-button matDatepickerApply>{{ 'general.apply' | translate }}</button>
                    </mat-datepicker-actions>
                  </mat-datepicker>
                  @if (group.get("beginn")?.invalid) {
                    <mat-error>{{ 'general.errors.required' |translate }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>

            <div class="certificate__field">
              @if (!editMode) {
                <mat-label class="certificate__question">{{ 'certificates.certifyingBody' | translate }}</mat-label>
                <p>{{ group.value.schulungsanbieter }}</p>
              } @else {
                <mat-form-field>
                  <mat-label class="certificate__question">{{ 'certificates.certifyingBody' | translate }}</mat-label>
                  <input required matInput type="text" formControlName="schulungsanbieter" [maxlength]="LIMITS.SHORT_LABEL"/>
                  <mat-hint align="end">{{ (group.get('schulungsanbieter')?.value?.length || 0) }}/{{ LIMITS.SHORT_LABEL }}</mat-hint>
                  @if (group.get("schulungsanbieter")?.hasError('required')) {
                    <mat-error>{{ 'general.errors.required' |translate }}</mat-error>
                  }
                  @if (group.get("schulungsanbieter")?.hasError('maxlength')) {
                    <mat-error>{{ 'general.validation.maxLength' | translate: { max: LIMITS.SHORT_LABEL } }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>

            <div class="certificate__field">
              @if (!editMode) {
                <mat-label class="certificate__question">{{ 'certificates.nameOfTheCertificate' | translate }}
                </mat-label>
                <p>{{ group.value.lehrgang }}</p>
              } @else {
                <mat-form-field>
                  <mat-label class="certificate__question">{{ 'certificates.nameOfTheCertificate' | translate }}
                  </mat-label>
                  <input
                    #searchInputCertificate
                    type="text"
                    matInput
                    (keyup)='filterCertificates(searchInputCertificate.value, idx)'
                    formControlName="lehrgang"
                    [maxlength]="LIMITS.SHORT_LABEL"
                    [matAutocomplete]="auto"
                    (blur)="validateCourseSelection(idx)"
                  >
                  <mat-autocomplete
                    #auto="matAutocomplete"
                    (optionSelected)="optionSelected($event, idx)"
                  >
                    @for (name of filteredCertificates[idx]; track name) {
                      <mat-option
                        [value]="name"
                      >
                        {{ name }}
                      </mat-option>
                    }
                  </mat-autocomplete>
                  <mat-hint align="end">{{ (group.get('lehrgang')?.value?.length || 0) }}/{{ LIMITS.SHORT_LABEL }}</mat-hint>
                  @if (group.get('lehrgang')?.hasError('required')) {
                    <mat-error>
                      {{ 'general.errors.required' | translate }}
                    </mat-error>
                  }
                  @if (group.get('lehrgang')?.hasError('maxlength')) {
                    <mat-error>{{ 'general.validation.maxLength' | translate: { max: LIMITS.SHORT_LABEL } }}</mat-error>
                  }
                </mat-form-field>
                @if (editMode) {
                  <div class="certificate__button-wrapper">
                    <button mat-flat-button
                            (click)='onAddRequestClick()'>{{ 'certificates.expandCertificateList' | translate }}
                      <mat-icon>add</mat-icon>
                    </button>
                  </div>
                }
              }
            </div>

            <div class="certificate__field">
              <mat-label class="certificate__question">{{ 'certificates.export' |translate }}</mat-label>
              @if (!editMode) {
                <p>
                  {{
                    group.value.forExport
                      ? ('certificates.yes' | translate)
                      : ('certificates.no' | translate)
                  }}
                </p>
              } @else {
                <mat-checkbox
                  class="for-export"
                  type="checkbox"
                  formControlName="forExport"
                />
              }
            </div>

            <div class="certificate__field certificate__upload">
              @if (!group.value.uploadId && !editMode) {
                <span class="certificate__validation-badge">
                {{ 'certificates.noCertificateUploaded' | translate }}
              </span>
                <app-field-warning [finding]="entryFinding(idx, 'uploadId')"></app-field-warning>
              }
              @if (editMode && !group.value.uploadId) {
                <input
                  type="file"
                  accept=".pdf"
                  #fileInput
                  (change)="addAttachment($event, idx)"
                  hidden
                />
                <button
                  mat-raised-button
                  color="primary"
                  (click)="fileInput.click()"
                  class="upload-btn"
                >
                  <mat-icon>upload</mat-icon>
                  {{ 'certificates.button.uploadCertificate' | translate }}
                </button>
                <span class="certificate__validation-badge">
                {{ 'certificates.noCertificateUploaded' | translate }}
              </span>
              } @else if (group.value.uploadId) {
                <div class="certificate__icon-wrapper">
                  <button mat-button (click)="downloadCertificates(group.value.uploadId)">
                    <mat-icon>download</mat-icon>
                    {{ 'certificates.button.downloadCertificate' | translate }}
                  </button>
                  @if (editMode) {
                    <button mat-button (click)="openDeleteAttachmentModal(idx)">
                      <mat-icon>delete</mat-icon>
                      {{ 'certificates.button.deleteCertificate' | translate }}
                    </button>
                  }
                </div>
              }
            </div>

            <div class="certificate__field">
              @if (!editMode) {
                <mat-label class="certificate__question">{{ 'certificates.trainingProvider' | translate }}</mat-label>
                <p>{{ group.value.trainingsanbieter }}</p>
              } @else {
                <mat-form-field>
                  <mat-label class="certificate__question">{{ 'certificates.trainingProvider' | translate }}</mat-label>
                  <input required matInput type="text" formControlName="trainingsanbieter" [maxlength]="LIMITS.SHORT_LABEL"/>
                  <mat-hint align="end">{{ (group.get('trainingsanbieter')?.value?.length || 0) }}/{{ LIMITS.SHORT_LABEL }}</mat-hint>
                  @if (group.get("trainingsanbieter")?.hasError('required')) {
                    <mat-error>{{ 'general.errors.required' |translate }}</mat-error>
                  }
                  @if (group.get("trainingsanbieter")?.hasError('maxlength')) {
                    <mat-error>{{ 'general.validation.maxLength' | translate: { max: LIMITS.SHORT_LABEL } }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>

            <div class="certificate__field">
              @if (!editMode) {
                <mat-label class="certificate__question">{{ 'certificates.certificateNumber' | translate }}</mat-label>
                <p>{{ group.value.zertifikatnummer }}</p>
              } @else {
                <mat-form-field>
                  <mat-label class="certificate__question">{{ 'certificates.certificateNumber' | translate }}
                  </mat-label>
                  <input required type="text" matInput formControlName="zertifikatnummer" [maxlength]="LIMITS.SHORT_LABEL"/>
                  <mat-hint align="end">{{ (group.get('zertifikatnummer')?.value?.length || 0) }}/{{ LIMITS.SHORT_LABEL }}</mat-hint>
                  @if (group.get("zertifikatnummer")?.hasError('required')) {
                    <mat-error>{{ 'general.errors.required' |translate }}</mat-error>
                  }
                  @if (group.get("zertifikatnummer")?.hasError('maxlength')) {
                    <mat-error>{{ 'general.validation.maxLength' | translate: { max: LIMITS.SHORT_LABEL } }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>

            @if (editMode) {
              <div class="certificate__save-button-div">
                <button
                  mat-mini-fab
                  color="primary"
                  (click)="openDeleteModal(idx)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }
          </div>
        </mat-card>
      }
    </div>

    @if (editMode) {
      <div class="certificate__add-button">
        <button mat-flat-button type="button" (click)="newCertificate()">
          <mat-icon>add</mat-icon>
          {{ 'certificates.button.createNewCertificate' | translate }}
        </button>
      </div>
    }
  } @else {
    <mat-card appearance="outlined" class="certificate__no-data">
      <mat-card-content>{{ 'certificates.noCertificate' |translate }}</mat-card-content>
    </mat-card>
  }
</form>

<!-- NP20-822: Bei vielen Einträgen ist der Weg nach oben weit; Abbrechen und Speichern
     kleben beim Bearbeiten am unteren Rand und rasten am Ende des Abschnitts ein. -->
@if (editMode && !exportMode) {
  <div class="sticky-save" role="group" [attr.aria-label]="'general.sectionActionsEnd' | translate">
    <button mat-stroked-button type="button" [disabled]="isCancelDisabled" (click)="onCancelEdit()">
      {{ 'general.cancel' | translate }}
    </button>
    <button mat-flat-button type="button" [disabled]="!hasChanges() || !isValid() || isSaving" (click)="onToggleEdit()">
      {{ 'general.save' | translate }}
    </button>
  </div>
}

<app-modal
  modalId="addTraining"
  [title]="'request.buttons.certificates'"
  [(visible)]="showModalAddRequest"
  [showButtons]="true"
  (save)="addCertificateRequest()"
  [showClose]="true"
  [disabled]='addRequestFormInvalid'
  [contentTemplate]='certificateModal'
  [saveText]="'request.modals.submit'"
></app-modal>

<ng-template #certificateModal>
  <div class='certificate__sub-header'>
    <mat-icon class='certificate__modal-icon'>
      warning
    </mat-icon>
    {{ 'request.modals.requestInfo' | translate }}
  </div>
  <form>
    <mat-form-field class="certificate__form-field">
      <mat-label>
        {{ 'request.modals.name'| translate }}
      </mat-label>
      <input
        matInput
        name="requests"
        [(ngModel)]="newReq.name"
        (ngModelChange)="onAddRequestFormChange()"
        [maxlength]="LIMITS.SHORT_LABEL"
        #requestsField="ngModel"
        required
      />
      @if (requestsField.hasError('required') && requestsField.touched) {
        <mat-error>
          {{
            'general.errors.required' | translate
          }}
        </mat-error>
      }
      @if (requestsField.hasError('maxlength')) {
        <mat-error>{{ 'general.validation.maxLength' | translate: { max: LIMITS.SHORT_LABEL } }}</mat-error>
      }
    </mat-form-field>
  </form>
</ng-template>


<app-modal
  modalId="deleteCertificate"
  [title]="'certificates.modal.title'"
  [text]="'certificates.modal.text'"
  [(visible)]="showModal"
  [showButtons]="true"
  (save)="delete(currentIdx)"
  [showClose]="true"
  [saveText]="'general.delete'"
></app-modal>


<app-modal
  modalId="deleteCertificateAttachment"
  [title]="'certificates.modal.title'"
  [text]="'certificates.modal.text'"
  [(visible)]="showModalAttachment"
  [showButtons]="true"
  (save)="deleteAttachment(currentIdx)"
  [showClose]="true"
  [saveText]="'general.delete'"
></app-modal>
